import React, { useEffect, useState } from "react";
import "./homeCarousel.css";

import bg from "../Images/bg.png";
import choose from "../Images/choose.png";
import MM from "../Images/MM.png";

const slides = [
  {
    image: bg,
    alt: "Technology Expertise",
  },
  {
    image: MM,
    alt: "Our Process",
  },
  {
    image: choose,
    alt: "Why Choose ZeitaMax",
  },
];

export default function HomeCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const prevSlide = () => {
    setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  };

  return (
    <section className="zm-carousel">

      <div className="carousel-wrapper">

        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${activeIndex * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div className="slide" key={index}>
              <img
                src={slide.image}
                alt={slide.alt}
                className="carousel-image"
              />
            </div>
          ))}
        </div>

        <button className="carousel-btn prev" onClick={prevSlide}>
          ❮
        </button>

        <button className="carousel-btn next" onClick={nextSlide}>
          ❯
        </button>

      </div>

      <div className="carousel-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={activeIndex === index ? "dot active" : "dot"}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>

    </section>
  );
}